import React, { useContext, useEffect, useState } from 'react';
import { Button, Flex, Flexed, MainWrap, PhoneNumber, Scroll } from '../../utilities/Shared';
import UserContext from '../../Context/UserContext';
import axios from 'axios';
import { toast } from 'react-toastify';
import Moment from 'react-moment';
import { sortcsrreps, sortdate, sortfollowdate, sortit, sortnum } from '../../utilities/Sort';
import PrintComponent from '../../Printing/Salescsrlist';
import { getsalesrepinfo } from '../../utilities/InfoStuff';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import Followups from './Followups';
import { useNavigate } from 'react-router-dom';
import Editfollow from './Editfollow';
import { Edit } from 'lucide-react';
import Modal from '../../modals/Modal';

const SalesDash = () => {
  const { userInfo } = useContext(UserContext);
  const [csrjobs, setCsrjobs] = useState([]);
  const [salesjobs, setSalesjobs] = useState([]);
  const [salesreps, setSalesreps] = useState([]);
  const [order, setOrder] = useState("ASC");
  const [reset, setReset] = useState(false);
  const [statustext, setStatustext] = useState("On Incoming");
  const [loading, setLoading] = useState(true);
  const [follolist, setFollolist] = useState([]);
  const [error, setError] = useState(null);
    const [editfollo, setEditfollo] = useState(false);
    const [customer, setCustomer] = useState(null);
const nav = useNavigate()

  // State for column visibility
  const [columnVisibility, setColumnVisibility] = useState({
    job: true,
    customer: true,
    jobname: true,
    salesrep: true,
    quantity: true,
    dateentered: true,
    duedate: true,
    status: true,
  });

  const config = {
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
    }
  };

  // Toggle column visibility
  const toggleColumn = (column) => {
    setColumnVisibility((prev) => ({
      ...prev,
      [column]: !prev[column],
    }));
  };

  useEffect(() => {
    const getJobs = async () => {
      try {
        const tr = {
          csr: sessionStorage.getItem('eid')
        };
        const response = await axios.post(
          'https://highgroundsoftware.com/dash/dashboard/php/getcsrjobs.php',
          tr,
          config
        );
        const processedJobs = await getOps(response.data);
        setCsrjobs(processedJobs);
      } catch (err) {
        setError(err.message);
        toast.error(`Failed to fetch jobs: ${err.message}`);
      }
    };

    const getSalesReps = async () => {
      try {
        const response = await axios.get('https://highgroundapi.herokuapp.com/employee/sales');
        setSalesreps(response.data);
      } catch (err) {
        setError(err.message);
        toast.error(`Failed to fetch sales reps: ${err.message}`);
      }
    };

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        await Promise.all([getJobs(), getSalesReps()]);
      
      } catch (err) {
        setError(err.message);
        toast.error(`Error fetching data: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    return () => {};
  }, []);




useEffect(() => {
  getsaleJobs()
  getfollowupsthisweek()
},[salesreps])

  const getsaleJobs = async () => {
    try {
      const tr = {
        csr: sessionStorage.getItem('eid')
      };
      const response = await axios.post(
        'https://highgroundsoftware.com/dash/dashboard/php/getsalesjobs.php',
        tr,
        config
      );
      const processedJobs = await getOps(response.data);
      setSalesjobs(processedJobs);
    } catch (err) {
      setError(err.message);
      toast.error(`Failed to fetch jobs: ${err.message}`);
    }

  };

  const getfollowupsthisweek = async () => {


console.log(userInfo._id)
let h ={
  id:sessionStorage.getItem('trackuser')
}
 await axios.post(
        'https://highgroundapi.herokuapp.com/customers/thisweekfollowups',h)
       // 'http://localhost:5003/customers/thisweekfollowups',h)
  .then(res => {console.log(res.data);setFollolist(res.data[0]?.followup)})
  .catch(err => console.log(err))
   
  };
  

  const getOps = async (data) => {
    if (!data || !Array.isArray(data)) {
      console.warn('Invalid or empty jobs data:', data);
      return [];
    }

    const processedJobs = await Promise.all(
      data.map(async (job) => {
        const result = await goit(job);
        return result;
      })
    );

    const validJobs = processedJobs.filter(job => job !== null);
    return validJobs;
  };

  
  const goit = async (job) => {
    try {
      const r = {
        job: job?.job
      };

      const response = await axios.post(
        'https://highgroundsoftware.com/dash/dashboard/php/getalloperations.php',
        r,
        config
      );

      const ops = [...response.data].sort((a, b) => 
        parseInt(b.id) - parseInt(a.id)
      );

      return {
        ...job,
        test: ops.length > 0 ? ops[0]?.name : ''
      };
    } catch (err) {
      return null;
    }
  };

  const getsalesrepinfo = (id) => {
    let a = salesreps.filter(filt => filt.empId === id);
    return a[0]?.firstName + ' ' + a[0]?.lastName.substr(0, 1);
  };

  if (loading) return <MainWrap style={{ fontSize: "calc(1.3rem + .2vw)" }}>Loading...</MainWrap>;
  if (error) return <MainWrap style={{ fontSize: "calc(1.3rem + .2vw)" }}>Error: {error}</MainWrap>;


  const compareDateToToday = (followupDate) => {
    const today = new Date();
    if (!followupDate) return false;
    const date = new Date(followupDate);
    if (isNaN(date.getTime())) return false;
    return (
      date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate()
    );
  };


  const handleOpenEditModal = (selectedCustomer) => {
    console.log(selectedCustomer)
    if (loading) {
      console.log('Waiting for newlist update before opening modal');
      return;
    }
    const latestCustomer = follolist.find((item) => item._id === selectedCustomer._id) || selectedCustomer;
   console.log('Opening modal with customer:', latestCustomer);
 setCustomer(latestCustomer);
    setEditfollo(true);
  };
  return (

    <>
     <Modal
            show={editfollo && !loading}
            headerbgcolor="#8498AC"
            width="75%"
            headercolor="#144259"
            header="Edit Followup"
            onCancel={() => setEditfollo(false)}
            key={customer?._id}
          >
            <Editfollow
              onCancel={() => setEditfollo(false)}
              customer={customer}
              setCustomer={setCustomer}
              reset={reset}
              setReset={setReset}
            updateCustomerList={() => setFollolist()}
            />
          </Modal>
    <MainWrap>
      <Flexed alignItems="center">
        <Flex style={{ fontSize: "2rem", padding: "20px 0px" }}>
          Welcome Back {userInfo.preferredName}
        </Flex>
        <Flex textAlign="right"><Button onClick={() => nav('/indvcustomers')}>Follow Up's</Button></Flex>
        </Flexed>
        <Flexed>
        <Flex fontSize="var(--headerMedium)" padding="10px 0px">{userInfo.departments?.some(cat => cat.label === "Csr") ? csrjobs.length :salesjobs.length} Current Job(s)</Flex>
      </Flexed>
<Flexed>
{Object.keys(columnVisibility).map((column) => (
               <Flex> <label
                  key={column}
                  style={{
                    alignItems: 'center',
                    marginRight: '15px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  <input
                    type="checkbox"
                    checked={columnVisibility[column]}
                    onChange={() => toggleColumn(column)}
                    style={{ marginRight: '5px' }}
                  />
                  {column === 'csrSalesRep' ? 'CSR Sales Rep' : column.charAt(0).toUpperCase() + column.slice(1)}
                </label>
                </Flex>
              ))}
              <Flex flex="1.5"> <PrintComponent
            salesreps={salesreps}
            csrjobs={userInfo.departments?.some(cat => cat.label === "Csr") ? csrjobs: salesjobs}
            title={`${userInfo.firstName} Open Jobs`}
            columnVisibility={columnVisibility}
          /></Flex>
</Flexed>

      <Flexed style={{ borderBottom: "1px solid black", padding: "4px", background: "#8398AB", color: "white" }} className="hand">
        <Flex fontSize="var(--headerMedium)" onClick={e => sortnum('job', order, csrjobs, setCsrjobs, setOrder)}>Job#</Flex>
        <Flex flex="1.5" fontSize="var(--headerMedium)" onClick={e => sortit('customer', order, csrjobs, setCsrjobs, setOrder)}>Customer</Flex>
        <Flex flex="3" fontSize="var(--headerMedium)" onClick={e => sortit('jobname', order, csrjobs, setCsrjobs, setOrder)}>Job Name</Flex>
        <Flex flex="1.5" fontSize="var(--headerMedium)" onClick={e => sortit('salesrep', order, csrjobs, setCsrjobs, setOrder)}>Sales Rep</Flex>
        <Flex fontSize="var(--headerMedium)" onClick={e => sortnum('origquantity', order, csrjobs, setCsrjobs, setOrder)}>Quantity</Flex>
        <Flex fontSize="var(--headerMedium)" onClick={e => sortdate('dateentered', order, csrjobs, setCsrjobs, setOrder)}>Entered</Flex>
        <Flex fontSize="var(--headerMedium)" onClick={e => sortdate('duedate', order, csrjobs, setCsrjobs, setOrder)}>Due</Flex>
        <Flex fontSize="var(--headerMedium)" onClick={e => sortit('salesrep', order, csrjobs, setCsrjobs, setOrder)}>
          {userInfo.departments?.some(item => item.label === "CSR") && <>Sales Rep</>}
        </Flex>
        <Flex flex="2" onClick={e => sortit('test', order, csrjobs, setCsrjobs, setOrder)}>Status</Flex>
      </Flexed>
<Scroll height="40vh">
      <div style={{ border: "1px solid black" }}>
        {userInfo.departments?.some(cat => cat.label === "Csr") ? csrjobs.map(job => (
          <Flexed className="normalrow hand" key={job.job}>
            <Flex><a href={`/jobticket/${job?.job}`}>{job.job}</a></Flex>
            <Flex flex="1.5">{job.customer}</Flex>
            <Flex flex="3">{job.jobname}</Flex>
            <Flex flex="1.5">{getsalesrepinfo(job?. salesrep)}</Flex>
            <Flex>{job.quantity}</Flex>
            <Flex><Moment format="MM/DD/YYYY">{job.dateentered}</Moment></Flex>
            <Flex><Moment format="MM/DD/YYYY">{job.duedate}</Moment></Flex>
            <Flex>
              {userInfo.departments?.some(item => item.label === "CSR") &&
                salesreps?.filter(rep => rep.empId === job.salesrep).map(rep => (
                  rep.firstName + " " + rep.lastName.substr(0, 1)
                ))}
            </Flex>
            <Flex flex="2">{job.test || "On Incoming"}</Flex>
          </Flexed>
        )) : salesjobs.map(job => (
          <Flexed className="normalrow hand" key={job.job}>
            <Flex><a href={`/jobticket/${job?.job}`}>{job.job}</a></Flex>
            <Flex flex="1.5">{job.customer}</Flex>
            <Flex flex="3">{job.jobname}</Flex>
            <Flex flex="1.5">{getsalesrepinfo(job?. salesrep)}</Flex>
            <Flex>{job.quantity}</Flex>
            <Flex><Moment format="MM/DD/YYYY">{job.dateentered}</Moment></Flex>
            <Flex><Moment format="MM/DD/YYYY">{job.duedate}</Moment></Flex>
            <Flex>
              {userInfo.departments?.some(item => item.label === "CSR") &&
                salesreps?.filter(rep => rep.empId === job.salesrep).map(rep => (
                  rep.firstName + " " + rep.lastName.substr(0, 1)
                ))}
            </Flex>
            <Flex flex="2">{job.test || "On Incoming"}</Flex>
          </Flexed>
        ))}
      </div>
      </Scroll>
      <Flexed style={{fontSize:"calc(1.3rem + .2vw)", padding: '4px', margin: '25px 0px 0px 0px' }}>
        <Flex>Follow Up's for this week</Flex>
      </Flexed>
       <Flexed
             style={{ borderBottom: '1px solid black', padding: '4px', background: '#8398AB', color: 'white', margin: '5px 0px 0px 0px' }}
             className="hand"
           >
             <Flex flex="1.5" onClick={() => sortit('name', order, follolist, setFollolist, setOrder)}>
               Customer
             </Flex>
             <Flex>Contact</Flex>
             <Flex flex="2">Email</Flex>
             <Flex>Phone</Flex>
             <Flex onClick={() => sortfollowdate('followup', order, follolist, setFollolist, setOrder)}>Follow Date</Flex>
             <Flex flex="3" >
               Note
             </Flex>
             <Flex flex=".1"> </Flex>
           </Flexed>
           {
            follolist?.length === 0 && <div style={{fontSize:"calc(1.1rem + .2vw)",padding:"4px 0px"}}>No Follow Up's so far this week</div>
           }
<Scroll height="20vh">
      <div style={{ border: "1px solid black" }}>
        {follolist?.map((job,index) => (
          <Flexed className="normalrow hand" key={index}>
            <Flex flex="1.5"><a href={`/customers/customer/${job?._id}`}>{job?.customerName}</a></Flex>
            <Flex >{job?.followupName}</Flex>
            <Flex flex="2"  onClick={() => job?.email && (window.location = `mailto:${job?.email}`)}>{job.email}</Flex>
            <Flex >{PhoneNumber(job.phone)}</Flex>

          <Flex className="" style={{fontWeight:compareDateToToday(job?.date) ? "bold" : "normal",fontSize:compareDateToToday(job?.date) ? "1.3rem" : "",color:compareDateToToday(job?.date) ? "rgb(255,0,0,.68)" : "inherit"}}>
            {job?.date ? new Date(job.date).toLocaleDateString() : ''}
          </Flex>
            <Flex flex="3">{job?.note}</Flex>
            <Flex flex=".1"> &nbsp;</Flex>
          </Flexed>
        ))}
      </div>
      </Scroll>
  
    </MainWrap>
    </>
  );
};

export default SalesDash;